<div class="mx-auto p-6">
  <div class="mb-2">
    <p id="gestion-des-bibliotheques" class="titre1 mt-4">
      {{ (isCreationMode ? 'LIBRARIES_MANAGEMENT.CREATE_LIBRARY' : 'LIBRARIES_MANAGEMENT.EDIT_LIBRARY') |
      translate }}
      <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">
        books_movies_and_music
      </mat-icon>
    </p>
  </div>

  @if (isLoading) {
    <div class="flex justify-center items-center h-64">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <div class="space-y-8">
      <div class="relative mt-12">
        <div>
          @if (!hasTitle()) {
            <div class="mb-4 text-rougeNovo">
              {{ 'LIBRARIES_MANAGEMENT.TITLE_REQUIRED' | translate }}
            </div>
          }
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            @for (language of supportedLanguages; track language) {
              <div>
                <label class="block text-sm font-medium">{{ language.label | translate }}</label>
                <input [title]="'nom' + language.code.toUpperCase()"
                  [(ngModel)]="bibliotheque.locales[language.code]"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500">
                </div>
              }
            </div>
          </div>
        </div>
        <div class="relative">
          <h2 class="titre2">{{ 'LIBRARIES_MANAGEMENT.CONTENT_MANAGEMENT' | translate }}</h2>
          <div class="grid grid-cols-2 gap-6">
            <div cdkDropList #availableList="cdkDropList" [cdkDropListData]="availablePackages"
              [cdkDropListConnectedTo]="[bibliothequeList]"
              class="p-6 rounded-lg border border-gray-300 min-h-[400px] flex flex-col"
              (cdkDropListDropped)="onDrop($event)">
              <div class="flex justify-between items-center mb-4">
                <h3 class="titre3">{{ 'LIBRARIES_MANAGEMENT.AVAILABLE_PACKAGES' | translate }}
                </h3>
              </div>
              <div class="mb-4">
                <input type="text" [(ngModel)]="searchAvailable" (ngModelChange)="filterAvailablePackages()"
                  placeholder="{{ 'LIBRARIES_MANAGEMENT.SEARCH' | translate }}"
                  class="w-full px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500">
                </div>
                <div class="flex-1 space-y-4 overflow-y-auto max-h-[280px]">
                  @for (package of availablePackages; track package) {
                    <div cdkDrag>
                      <app-package-card [package]="package"></app-package-card>
                    </div>
                  }
                </div>
              </div>
              <div cdkDropList #bibliothequeList="cdkDropList" [cdkDropListData]="packagesInBibliotheque"
                [cdkDropListConnectedTo]="[availableList]"
                class="p-6 rounded-lg border border-gray-300 min-h-[400px] flex flex-col"
                (cdkDropListDropped)="onDrop($event)">
                <div class="flex justify-between items-center mb-4">
                  <h3 class="titre3">{{ 'LIBRARIES_MANAGEMENT.PACKAGES_IN_LIBRARY' | translate }}
                  </h3>
                  <button (click)="clearPackages()"
                    class="px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 flex items-center gap-2">
                    <mat-icon>clear_all</mat-icon>
                    {{ 'LIBRARIES_MANAGEMENT.CLEAR' | translate }}
                  </button>
                </div>
                <div class="mb-4">
                  <input type="text" [(ngModel)]="searchInLibrary" (ngModelChange)="filterPackagesInLibrary()"
                    placeholder="{{ 'LIBRARIES_MANAGEMENT.SEARCH' | translate }}"
                    class="w-full px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500">
                  </div>
                  <div class="flex-1 space-y-4 overflow-y-auto max-h-[280px]">
                    @for (package of packagesInBibliotheque; track package) {
                      <div cdkDrag>
                        <app-package-card [package]="package"></app-package-card>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="relative">
              <h2 class="titre2">{{ 'LIBRARIES_MANAGEMENT.ASSIGNMENTS' | translate }}</h2>
              <div class="grid grid-cols-3 gap-6">
                <div class="p-6 rounded-md border border-gray-300">
                  <h3 class="titre3 mb-4">{{ 'LIBRARIES_MANAGEMENT.ENTITIES' | translate }}</h3>
                  <mat-select [formControl]="entiteFilterCtrl" (selectionChange)="onEntiteSelected($event)"
                    class="w-full h-8 border border-gray-300 rounded-md px-3 py-1">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="entiteFilterCtrl"
                        [placeholderLabel]="'LIBRARIES_MANAGEMENT.SEARCH' | translate"
                        [noEntriesFoundLabel]="'LIBRARIES_MANAGEMENT.NO_RESULTS' | translate">
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (entite of filteredEntitesSearch | async; track entite) {
                      <mat-option [value]="entite.novoEntiteId">
                        {{entite.nom}}
                      </mat-option>
                    }
                  </mat-select>
                  <div class="mt-4 overflow-y-auto max-h-[300px]">
                    @for (entite of selectedEntites; track entite) {
                      <div
                        class="bg-roseNovo shadow-sm rounded-[30px] p-2 hover:shadow-md transition-shadow duration-200 mb-2">
                        <div class="flex items-center justify-between">
                          <div class="flex items-center gap-2">
                            <mat-icon class="material-symbols-outlined text-rougeNovo"
                            style="font-size: 24px;">group</mat-icon>
                            <div class="truncate my-auto text-rougeNovo">{{entite.nom}}</div>
                          </div>
                          <button (click)="removeEntite(entite.novoEntiteId)" class="text-rougeNovo">
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="p-6 rounded-md border border-gray-300">
                  <h3 class="titre3 mb-4">{{ 'LIBRARIES_MANAGEMENT.REGROUPEMENTS' | translate }}</h3>
                  <mat-select [formControl]="regroupementFilterCtrl"
                    (selectionChange)="onRegroupementSelected($event)"
                    class="w-full h-8 border border-gray-300 rounded-md px-3 py-1">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="regroupementFilterCtrl"
                        [placeholderLabel]="'LIBRARIES_MANAGEMENT.SEARCH' | translate"
                        [noEntriesFoundLabel]="'LIBRARIES_MANAGEMENT.NO_RESULTS' | translate">
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (regroupement of filteredRegroupementsSearch | async; track regroupement) {
                      <mat-option
                        [value]="regroupement.regroupementId">
                        {{regroupement.nomLong}} ({{regroupement.typeRegroupementCourt}})
                      </mat-option>
                    }
                  </mat-select>
                  <div class="mt-4 overflow-y-auto max-h-[300px]">
                    @for (regroupement of selectedRegroupements; track regroupement) {
                      <div
                        class="bg-roseNovo shadow-sm rounded-[30px] p-2 hover:shadow-md transition-shadow duration-200 mb-2">
                        <div class="flex items-center justify-between">
                          <div class="flex items-center gap-2">
                            <mat-icon class="material-symbols-outlined text-rougeNovo"
                            style="font-size: 24px;">folder</mat-icon>
                            <div class="truncate my-auto text-rougeNovo">{{regroupement.nomLong}}
                            ({{regroupement.typeRegroupementCourt}})</div>
                          </div>
                          <button (click)="removeRegroupement(regroupement.regroupementId)"
                            class="text-rougeNovo">
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="p-6 rounded-md border border-gray-300">
                  <h3 class="titre3 mb-4">{{ 'LIBRARIES_MANAGEMENT.ASSOCIATIONS' | translate }}</h3>
                  <mat-select [formControl]="associationFilterCtrl" (selectionChange)="onAssociationSelected($event)"
                    class="w-full h-8 border border-gray-300 rounded-md px-3 py-1">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="associationFilterCtrl"
                        [placeholderLabel]="'LIBRARIES_MANAGEMENT.SEARCH' | translate"
                        [noEntriesFoundLabel]="'LIBRARIES_MANAGEMENT.NO_RESULTS' | translate">
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (association of filteredAssociationsSearch | async; track association) {
                      <mat-option
                        [value]="association.novoEntiteId">
                        {{association.denomination}}
                      </mat-option>
                    }
                  </mat-select>
                  <div class="mt-4 overflow-y-auto max-h-[300px]">
                    @for (association of selectedAssociations; track association) {
                      <div
                        class="bg-roseNovo shadow-sm rounded-[30px] p-2 hover:shadow-md transition-shadow duration-200 mb-2">
                        <div class="flex items-center justify-between">
                          <div class="flex items-center gap-2">
                            <mat-icon class="material-symbols-outlined text-rougeNovo"
                            style="font-size: 24px;">business</mat-icon>
                            <div class="truncate my-auto text-rougeNovo">{{association.denomination}}</div>
                          </div>
                          <button (click)="removeAssociation(association.novoEntiteId)" class="text-rougeNovo">
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-end gap-4 mt-8">
              <button (click)="cancel()" class="btn-secondary-novo">
                {{ 'LIBRARIES_MANAGEMENT.CANCEL' | translate }}
              </button>
              <button (click)="save()" [disabled]="!isValid()" class="btn-primary-novo"
                [ngClass]="{'opacity-50 cursor-not-allowed': !isValid()}">
                {{ 'LIBRARIES_MANAGEMENT.SAVE' | translate }}
              </button>
            </div>
          </div>
        }
      </div>